import { render } from "./VerticalStepper.vue?vue&type=template&id=37bb003e&scoped=true"
import script from "./VerticalStepper.vue?vue&type=script&lang=js"
export * from "./VerticalStepper.vue?vue&type=script&lang=js"

import "./VerticalStepper.vue?vue&type=style&index=0&id=37bb003e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37bb003e"]])

export default __exports__